export class FilterBase {
    term: string;
    page: number;
    isActive: boolean;
}
